import React, { useState, useEffect } from 'react';
import { getAuthToken, handleAuthTokenError, BASEURI } from '../utils';
import { useIntl } from 'react-intl';
import loadingWhite from '../loading_white.svg';
import loadingIcon from '../loading.svg';

export default function PlotLineTable({ plotLines, chartId, updateChartPlotLines }) {
    const [rows, setRows] = useState([]);
    const [editingIndex, setEditingIndex] = useState(null);
    const [newRow, setNewRow] = useState({ title: '', color: '#000000', value: '', enabled: true });
    const [invalidTitle, setInvalidTitle] = useState(false);
    const [invalidValue, setInvalidValue] = useState(false);
    const [deletedId, setDeletedId] = useState(null);
    const [saving, setSaving] = useState(false);
    const [adding, setAdding] = useState(false);

    const intl = useIntl();

    useEffect(() => {
        setRows(plotLines || []);
    }, [plotLines])


    const handleChange = (e, index) => {
        const { name, value, type, checked } = e.target;
        const updated = [...rows];
        updated[index][name] = type === 'checkbox' ? checked : value;
        setRows(updated);
    };


    const handleAdd = () => {
        setAdding(true);
        setEditingIndex(null);

        if (newRow.title.length == 0) {
            setInvalidTitle(true)
            setAdding(false);
            return
        }
        else
            setInvalidTitle(false)

        if (newRow.value.length == 0) {
            setInvalidValue(true)
            setAdding(false);
            return
        }
        else
            setInvalidValue(false)

        let url = `${BASEURI}/api/chart/custom-plot-line/`,
            options = {
                method: 'POST',
                body: JSON.stringify({ ...newRow, chart: chartId }),
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => {
                        return response.json();
                    })
                    .then(createdPlotLine => {
                        setAdding(false);
                        setRows([...rows, { ...createdPlotLine }]);
                        updateChartPlotLines([...rows, { ...createdPlotLine }], chartId);
                        setNewRow({ title: '', color: '#000000', value: '', enabled: true });

                    }).catch(() => {
                        setAdding(false);
                    });

            });


    };

    const handleEdit = (index) => {
        setEditingIndex(index);
    };

    const handleSave = (id) => {
        setSaving(true);
        const updated = rows.find(item => item.id === id);

        if (updated.title.length == 0) {
            setInvalidTitle(true)
            setSaving(false);
            return
        }
        else
            setInvalidTitle(false)


        if (updated.value.length == 0) {
            setInvalidValue(true);
            setSaving(false);
            return
        }
        else
            setInvalidValue(false)


        let url = `${BASEURI}/api/chart/custom-plot-line/${id}/`,
            options = {
                method: 'PUT',
                body: JSON.stringify(updated),
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {

                options.headers.Authorization = `Bearer  ${token}`;

                fetch(url, options)
                    .then((response) => {
                        return response.json();
                    })
                    .then(updatedPlotLine => {
                        setSaving(false);
                        updateChartPlotLines(rows, chartId);

                    }).catch(() => {
                        setSaving(false);
                    });
            });

        setEditingIndex(null);
    };

    const handleDelete = (id) => {
        setDeletedId(id);
        let url = `${BASEURI}/api/chart/custom-plot-line/${id}/`,
            options = {
                method: 'DELETE',
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }

        getAuthToken()
            .then(token => token)
            .catch(handleAuthTokenError)
            .then(token => {
                options.headers.Authorization = `Bearer  ${token}`;
                fetch(url, options)
                    .then((response) => {
                        setDeletedId(null);
                        const updatedList = rows.filter(item => item.id !== id);
                        setRows(updatedList)
                        updateChartPlotLines(updatedList, chartId);
                    }).catch(() => {
                        setDeletedId(null);
                    })
                    ;
            });
    };

    return (
        <div className="py-4 w-full">
            <h2 className="text-xl font-semibold mb-4">{intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.chartLines', defaultMessage: 'Chart Lines' })}</h2>
            <table className="w-full border rounded-md overflow-hidden">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="p-2 text-left">{intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.title', defaultMessage: 'Title' })}</th>
                        <th className="p-2 text-left">{intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.color', defaultMessage: 'Color' })}</th>
                        <th className="p-2 text-left">{intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.value', defaultMessage: 'Value' })}</th>
                        <th className="p-2 text-left">{intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.enabled', defaultMessage: 'Enabled' })}</th>
                        <th className="p-2">{intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.actions', defaultMessage: 'Actions' })}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr key={i} className="border-t">
                            {editingIndex === i ? (
                                <>
                                    <td className="p-2">
                                        <input
                                            type="text"
                                            name="title"
                                            value={row.title}
                                            onChange={(e) => handleChange(e, i)}
                                            className={`border p-1 rounded w-full ${(invalidTitle & editingIndex !== null) && "border-red-500"}`}
                                        />
                                    </td>
                                    <td className="p-2">
                                        <input
                                            type="color"
                                            name="color"
                                            value={row.color}
                                            onChange={(e) => handleChange(e, i)}
                                        />
                                    </td>
                                    <td className="p-2">
                                        <input
                                            type="number"
                                            name="value"
                                            value={row.value}
                                            onChange={(e) => handleChange(e, i)}
                                            className={`border p-1 rounded w-full ${(invalidValue & editingIndex !== null) && "border-red-500"}`}
                                        />
                                    </td>
                                    <td className="p-2 text-center">
                                        <input
                                            type="checkbox"
                                            name="enabled"
                                            checked={row.enabled}
                                            onChange={(e) => handleChange(e, i)}
                                        />
                                    </td>
                                    <td className="p-2 text-center">
                                        <button
                                            className="bg-green-600 text-white px-2 py-1 rounded"
                                            onClick={() => handleSave(row.id)}
                                        >
                                            {saving ? <img style={{ width: '20px' }} src={loadingWhite} alt='loading' /> :
                                                intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.save', defaultMessage: 'Save' })}
                                        </button>
                                    </td>
                                </>
                            ) : (
                                <>
                                    <td className="p-2">{row.title}</td>
                                    <td className="p-2">
                                        <span
                                            className="inline-block w-5 h-5 rounded"
                                            style={{ backgroundColor: row.color }}
                                        ></span>
                                    </td>
                                    <td className="p-2">{row.value}</td>
                                    <td className="p-2 text-center">
                                        <input type="checkbox" checked={row.enabled} disabled />
                                    </td>
                                    <td className="p-2 text-center whitespace-nowrap">
                                        <div className="flex flex-nowrap justify-center items-center gap-4">
                                            <button
                                                type="button"
                                                className="text-green-600 hover:underline shrink-0"
                                                onClick={() => handleEdit(i)}
                                            >
                                                {intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.edit', defaultMessage: 'Edit' })}
                                            </button>
                                            <button
                                                type="button"
                                                className="text-red-600 hover:underline shrink-0"
                                                onClick={() => handleDelete(row.id)}
                                            >
                                                {deletedId === row.id ? (
                                                    <img style={{ width: '20px' }} src={loadingIcon} alt="loading" />
                                                ) : (
                                                    intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.delete', defaultMessage: 'Delete' })
                                                )}
                                            </button>
                                        </div>
                                    </td>

                                </>
                            )}
                        </tr>
                    ))}
                    <tr className="border-t bg-gray-50">
                        <td className="p-2">
                            <input
                                type="text"
                                name="title"
                                value={newRow.title}
                                onChange={(e) => setNewRow({ ...newRow, title: e.target.value })}
                                className={`border p-1 rounded w-full ${(invalidTitle & editingIndex === null) && "border-red-500"}`}
                                placeholder={intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.title', defaultMessage: 'Title' })}
                            />
                        </td>
                        <td className="p-2">
                            <input
                                type="color"
                                name="color"
                                value={newRow.color}
                                onChange={(e) => setNewRow({ ...newRow, color: e.target.value })}
                            />
                        </td>
                        <td className="p-2">
                            <input
                                type="number"
                                name="value"
                                value={newRow.value}
                                onChange={(e) => setNewRow({ ...newRow, value: e.target.value })}
                                className={`border p-1 rounded w-full ${(invalidValue & editingIndex === null) && "border-red-500"}`}
                                placeholder={intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.value', defaultMessage: 'Value' })}
                            />
                        </td>
                        <td className="p-2 text-center">
                            <input
                                type="checkbox"
                                name="enabled"
                                checked={newRow.enabled}
                                onChange={(e) => setNewRow({ ...newRow, enabled: e.target.checked })}
                            />
                        </td>
                        <td className="p-2 text-center">
                            <button
                                className="bg-green-600 text-white px-3 py-1 rounded"
                                onClick={handleAdd}
                            >
                                {adding ? <img style={{ width: '20px' }} src={loadingWhite} alt='loading' /> :
                                    intl.formatMessage({ id: 'app.chart.widgetDialog.plotLine.add', defaultMessage: 'Add' })}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
